// Meta Pixel helper – wraps window.fbq calls safely.
// Pixel base script is loaded in index.html.

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

export type MetaPixelEvent =
  | 'PageView'
  | 'ViewContent'
  | 'InitiateCheckout'
  | 'AddToCart'
  | 'Purchase'
  | 'Lead'
  | 'CompleteRegistration'
  | 'Contact'
  | 'Subscribe';

export interface MetaPixelEventParams {
  value?: number;
  currency?: string;
  content_name?: string;
  content_category?: string;
  content_ids?: string[];
  content_type?: 'product' | 'product_group';
  num_items?: number;
  [key: string]: unknown;
}

const isAvailable = (): boolean =>
  typeof window !== 'undefined' && typeof window.fbq === 'function';

export const trackPageView = (): void => {
  if (!isAvailable()) return;
  try {
    window.fbq!('track', 'PageView');
  } catch (e) {
    // no-op
  }
};

export const trackEvent = (
  event: MetaPixelEvent,
  params?: MetaPixelEventParams
): void => {
  if (!isAvailable()) return;
  try {
    if (params) {
      window.fbq!('track', event, params);
    } else {
      window.fbq!('track', event);
    }
  } catch (e) {
    // no-op
  }
};

export const trackCustomEvent = (
  name: string,
  params?: Record<string, unknown>
): void => {
  if (!isAvailable()) return;
  try {
    if (params) {
      window.fbq!('trackCustom', name, params);
    } else {
      window.fbq!('trackCustom', name);
    }
  } catch (e) {
    // no-op
  }
};
